export const ModelListPK = [
    {
        'group':'Pickstone',
        'name':'Google',
        'models':
        [
            {name:'SATELLITE',url:'./models/pickstone/google/pk_google-transformed.glb'},
        ]   

    },
    {
        'group':'Pickstone',
        'name':'Pits',
        'models':
        [
            {name:'PK_PIT',url:'./models/pickstone/pits/pk_pit-transformed.glb'},
            {name:'PK_PIT_DESIGN',url:'./models/pickstone/pits/PK_PIT_DESIGN_280524-transformed.glb'},
            ]   

    },
    {
        'group':'Pickstone',
        'name':'Development.SCAN_SIMPLIFIED',
        'models':
        [
            // {name:'2L_SCAN_Simplified',url:'./models/pickstone/scan/2L_SCAN_CE-transformed.glb'},
            // {name:'3L_SCAN_Simplified',url:'./models/pickstone/scan/3L_SCAN_CE-transformed.glb'},
            // {name:'4L_SCAN_Simplified',url:'./models/pickstone/scan/4L_SCAN_CE-transformed.glb'},
            // {name:'5L_SCAN_Simplified',url:'./models/pickstone/scan/5L_SCAN_CE-transformed.glb'},
            // {name:'6L_SCAN_Simplified',url:'./models/pickstone/scan/6L_SCAN_CE-transformed.glb'},
            // {name:'FullScan',url:'./models/pickstone/scan/PICKSTONE_SURVEYS_SCANS.glb'},
            // {name:'FullScan1',url:'./models/pickstone/scan/PICKSTONE_SURVEYS_SCANS1.glb'},
            {name:'1L_STOPE',url:'./models/pickstone/scan/APRIL2024/1L_STOPEo.glb'},
            {name:'2L_SCAN',url:'./models/pickstone/scan/APRIL2024/2L_SCANo.glb'},
            {name:'2L_STOPE',url:'./models/pickstone/scan/APRIL2024/2L_STOPEo.glb'},
            {name:'2L_STOPE01',url:'./models/pickstone/scan/APRIL2024/2L_STOPE01o.glb'},
            {name:'2L_WINZE',url:'./models/pickstone/scan/APRIL2024/2L_WINZEo.glb'},
            {name:'3L_SCAN',url:'./models/pickstone/scan/APRIL2024/3L_SCANo.glb'},
            {name:'3L_STOPE',url:'./models/pickstone/scan/APRIL2024/3L_STOPEo.glb'},
            {name:'3L_STOPE01',url:'./models/pickstone/scan/APRIL2024/3L_STOPE01o.glb'},
            {name:'3L_STOPE02',url:'./models/pickstone/scan/APRIL2024/3L_STOPE02o.glb'},
            {name:'3L_STOPE03',url:'./models/pickstone/scan/APRIL2024/3L_STOPE03o.glb'},
            {name:'3L_STOPE04',url:'./models/pickstone/scan/APRIL2024/3L_STOPE04o.glb'},
            {name:'4L_SCAN',url:'./models/pickstone/scan/APRIL2024/4L_SCANo.glb'},
            {name:'4L_SL_SCAN',url:'./models/pickstone/scan/APRIL2024/4L_SL_SCANo.glb'},
            {name:'5L_SCAN',url:'./models/pickstone/scan/APRIL2024/5L_SCANo.glb'},
            {name:'6L_SCAN',url:'./models/pickstone/scan/APRIL2024/6L_SCANo.glb'},
            {name:'7L_SCAN',url:'./models/pickstone/scan/APRIL2024/7L_SCANo.glb'},
            {name:'SCANS',url:'./models/pickstone/scan/PICKSTONE_SURVEYS_SCANS2.glb'},
            {name:'SCAN_1224',url:'./models/pickstone/scan/scan1224_compressed1.glb'},
        ]   

    },
    {
        'group':'Pickstone',
        'name':'Development.RTZ',
        'models':
        [
            {name:'RTZ_SHAFTS',url:'./models/pickstone/rtz/PK_UG_MINED_OUT_SHAFTS-transformed.glb'},
            {name:'RTZ_DRIVES',url:'./models/pickstone/rtz/PK_UG_MINED_OUT_LEVELS_UPDATE_140224-transformed.glb'},
            {name:'RTZ_DRIVES_CORRECTED',url:'./models/pickstone/rtz/PK_UG_MINED_OUT_LEVELS_FORCED.glb'},
            {name:'RTZ_STOPES',url:'./models/pickstone/rtz/PK_UG_MINED_OUT_STOPES1-transformed.glb'},
            {name:'PK_UG_OLD_RAISES',url:'./models/pickstone/rtz/PK_UG_OLD_RAISES.glb'},
            {name:'PK_UG_OLD_RAISES1',url:'./models/pickstone/rtz/PK_UG_OLD_RAISES1.glb'},
            {name:'PK_UG_OLD_DRIVES',url:'./models/pickstone/rtz/PK_UG_OLD_DRIVES.glb'},
            {name:'RTZ_BOXES',url:'./models/pickstone/rtz/PK_UG_BOXES-transformed.glb'},
            {name:'RTZ_GEO',url:'./models/pickstone/rtz/PK_UG_GEO-transformed.glb'},
            {name:'RTZ_CROSS_SECTIONS',url:'./models/pickstone/rtz/PK_UG_RTZ_CrossSections.glb'},
            {name:'RTZ_CROSS_SILL',url:'./models/pickstone/rtz/PK_UG_RTZ_SILL.glb'},
            {name:'RTZ_STOPES_SECTIONS',url:'./models/pickstone/rtz/PK_UG_RTZ_STOPES.glb'},

            
        ]   

    },
    {
        'group':'Pickstone',
        'name':'Engineering',
        'models':
        [
            {name:'Dewatering',url:'./models/pickstone/engineering/dewatering_.glb', shouldBloom:true},
            {name:'Power',url:'./models/pickstone/engineering/power.glb', shouldBloom:true},

            
        ]   

    },
    {
        'group':'Pickstone',
        'name':'Development.Survey',
        'models':
        [
            // {name:'DXF_SURV',type:'dxf',url:'./models/pickstone/survey/comb.dxf'},

            {name:'PK_UPDATES',url:'./models/pickstone/survey/pk_updates.glb'},
            {name:'PK_STOPES_0223',url:'./models/pickstone/survey/PK_UG_MINED_OUT_STOPES_2023-transformed.glb'},
            {name:'PK_DRIVES_0423',url:'./models/pickstone/survey/PK_SURV_DRV_0423-transformed.glb'},
            {name:'PK_EOM_1122',url:'./models/pickstone/survey/PK_EOM_1122-transformed.glb'},
            {name:'PK_EOM_1222',url:'./models/pickstone/survey/PK_EOM_1222-transformed.glb'},
            {name:'PK_EOM_0123',url:'./models/pickstone/survey/PK_EOM_0123-transformed.glb'},
            {name:'PK_EOM_0223',url:'./models/pickstone/survey/PK_EOM_0223-transformed.glb'},
            {name:'PK_EOM_0323',url:'./models/pickstone/survey/PK_EOM_0323-transformed.glb'},
            {name:'PK_EOM_0423',url:'./models/pickstone/survey/PK_EOM_0423-transformed.glb'},
            {name:'PK_EOM_0523',url:'./models/pickstone/survey/PK_EOM_0523-transformed.glb'},
            {name:'PK_EOM_1123',url:'./models/pickstone/survey/PK_EOM_1123-transformed.glb'},
            {name:'SURVEY_0724',url:'./models/pickstone/survey/SURVEY_0724.glb'},
            {name:'SURVEY_0125',url:'./models/pickstone/survey/SURVEY_0125.glb'},
            {name:'SURVEY_0325',url:'./models/pickstone/survey/SURVEY_0325.glb'},
            {name:'SURVEY_0325_SOLID',url:'./models/pickstone/survey/SURVEY_0325_SOLID.glb'},
            {name:'SURV_0225',url:'./models/pickstone/survey/SURV_01022025.glb'},
            {name:'concession_voids',url:'./models/pickstone/survey/concession_voids.glb'},
        ]   

    },
    {
        'group':'Pickstone',
        'name':'Development.PLAN',
        'models':
        [
            {name:'DRILLING_TARGETS',url:'./models/pickstone/plan/DRILLING_TRAGETS.glb'},
            {name:'PK_PLAN_0423',url:'./models/pickstone/plan/PK_Plan_0423-transformed.glb'},
            {name:'PK_PLAN_0523',url:'./models/pickstone/plan/PK_Plan_0523-transformed.glb'},
            {name:'PK_PLAN_0623',url:'./models/pickstone/plan/PK_Plan_0623-transformed.glb'},
            {name:'PK_PLAN_0723',url:'./models/pickstone/plan/PK_Plan_0723-transformed.glb'},
            {name:'PK_PLAN_0923',url:'./models/pickstone/plan/PK_Plan_0923-transformed.glb'},
            {name:'PK_PLAN_1023',url:'./models/pickstone/plan/PK_Plan_1023-transformed.glb'},  
            {name:'HULL_FEB2025',url:'./models/pickstone/plan/HULL_FEB2025.glb'},
            {name:'HULL_JAN2025',url:'./models/pickstone/plan/HULL_JAN2025.glb'},
        ]   

    },
    {
        'group':'Pickstone',
        'name':'Development.LOM',
        'models':
        [

            {name:'LOM_DEV',url:'./models/pickstone/plan/LOM_DEV.glb'},
            {name:'SECTIONS',url:'./models/pickstone/plan/SECTIONS.glb'},
            //{name:'LOM_DEV',url:'./models/pickstone/plan/LOM_DEV-transformed.glb'},
            {name:'LOM_STOPES',url:'./models/pickstone/plan/LOM_STOPES-transformed.glb'},
            {name:'STOPES_2025_APRIL',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2025_APRIL.glb'},
            {name:'STOPES_2025_Q1',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2025_Q1.glb'},
            {name:'STOPES_P1',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_P1-transformed.glb'},
            {name:'STOPES_P2',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_P2-transformed.glb'},
            {name:'STOPES_2023',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2023.glb'},
            {name:'STOPES_2024',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2024.glb'},
            {name:'STOPES_2025',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2025.glb'},
            {name:'STOPES_2026',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2026.glb'},
            {name:'STOPES_2027',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2027.glb'},
            {name:'STOPES_2028',url:'./models/pickstone/plan/PK_UG_PLANNED_STOPES_2028.glb'},
            {name:'DECLINE_5L',url:'./models/pickstone/plan/PK_UG_5L_Decline-transformed.glb'},
            {name:'LOBE',url:'./models/pickstone/plan/LOBE.glb'},
        ]   

    },

    {
        'group':'Pickstone',
        'name':'Geology.ConceptualDesign',
        'models':
        [
            {name:'PE_ADIT',url:'./models/pickstone/plan/peerless_adit.glb'},
            {name:'PLANNED_CUBBIES',url:'./models/pickstone/tendai_model/6L_Cubbies-transformed.glb'},
            {name:'6L_DECLINE',url:'./models/pickstone/tendai_model/6L_Decline-transformed.glb'},
            {name:'CH_MODEL',url:'./models/pickstone/tendai_model/concession_model-transformed.glb'},
            {name:'CH_MODEL_B',url:'./models/pickstone/tendai_model/concession_model_B-transformed.glb'},
            {name:'DH_MODEL',url:'./models/pickstone/tendai_model/duchess_model-transformed.glb'},
            {name:'DH_MODEL_B',url:'./models/pickstone/tendai_model/duchess_model_B-transformed.glb'},
            {name:'PK_MODEL',url:'./models/pickstone/tendai_model/pickstone_model-transformed.glb'},
            {name:'PK_MODEL_B',url:'./models/pickstone/tendai_model/pickstone_model_B-transformed.glb'},

            
            {name:'DGM_OREBLOCKS',url:'./models/pickstone/geological_models/DGM_OREBLOCKS.glb'},

            {name:'DuchessOrebody0824',url:'./models/pickstone/tendai_model/DuchessOrebody_050924.glb'},
            {name:'PickstoneOrebody0824',url:'./models/pickstone/tendai_model/PickstoneOrebody_050924.glb'},
            {name:'PKHGC1Orebody0824',url:'./models/pickstone/tendai_model/PKHGC1Orebody_050924.glb'},
            {name:'PKHGC2Orebody0824',url:'./models/pickstone/tendai_model/PKHGC2Orebody_050924.glb'}
           // {name:'PK_OREBODY_TM',url:'./models/gltfs/TECT/PK_OREBODY_TM-transformed.glb'}, 
           // {name:'Development',url:'.models/pickstone/breckridge_models/Development-transformed.glb'}	  
        ]   

    },

    {
        'group':'Pickstone',
        'name':'Geology.ConceptualDesign',
        'models':
        [
            {name:'PE_ADIT',url:'./models/pickstone/plan/peerless_adit.glb'},
            {name:'PLANNED_CUBBIES',url:'./models/pickstone/tendai_model/6L_Cubbies-transformed.glb'},
            {name:'6L_DECLINE',url:'./models/pickstone/tendai_model/6L_Decline-transformed.glb'},
            {name:'CH_MODEL',url:'./models/pickstone/tendai_model/concession_model-transformed.glb'},
            {name:'CH_MODEL_B',url:'./models/pickstone/tendai_model/concession_model_B-transformed.glb'},
            {name:'CH_MODEL_1224',url:'./models/pickstone/GKupeta/ConcessionModelC.glb'},
            {name:'DH_MODEL',url:'./models/pickstone/tendai_model/duchess_model-transformed.glb'},
            {name:'DH_MODEL_B',url:'./models/pickstone/tendai_model/duchess_model_B-transformed.glb'},
            {name:'PK_MODEL',url:'./models/pickstone/tendai_model/pickstone_model-transformed.glb'},
            {name:'PK_MODEL_B',url:'./models/pickstone/tendai_model/pickstone_model_B-transformed.glb'},

            
            {name:'DGM_OREBLOCKS',url:'./models/pickstone/geological_models/DGM_OREBLOCKS.glb'},

            {name:'DuchessOrebody0824',url:'./models/pickstone/tendai_model/DuchessOrebody_050924.glb'},
            {name:'PickstoneOrebody0824',url:'./models/pickstone/tendai_model/PickstoneOrebody_050924.glb'},
            {name:'PKHGC1Orebody0824',url:'./models/pickstone/tendai_model/PKHGC1Orebody_050924.glb'},
            {name:'PKHGC2Orebody0824',url:'./models/pickstone/tendai_model/PKHGC2Orebody_050924.glb'}
           // {name:'PK_OREBODY_TM',url:'./models/gltfs/TECT/PK_OREBODY_TM-transformed.glb'}, 
           // {name:'Development',url:'.models/pickstone/breckridge_models/Development-transformed.glb'}	  
        ]   

    },

    {
        'group':'Pickstone',
        'name':'PKGeology.Central',
        'models':
        [
            { name: '4L_Central', url: './models/pickstone/central/4L_Central.glb' },
            { name: '12L_Central', url: './models/pickstone/central/12L_Central.glb' },
            { name: '24L_Central', url: './models/pickstone/central/24L_Central.glb' },
            { name: 'CentralMainDecline', url: './models/pickstone/central/CentralMainDecline.glb' },
            { name: 'CentralShaft', url: './models/pickstone/central/CentralShaft.glb' },
            { name: 'PeerlessWestDecline', url: './models/pickstone/central/PeerlessWestDecline.glb' },
            { name: 'Conveyor', url: './models/pickstone/central/Conveyor.glb' },
            ]   

    },

    {
        'group':'Pickstone',
        'name':'Geology.GeologicalShoots',
        'models':
        [
            {name:'Concession_Shoot',url:'./models/pickstone/breckridge_models/Concession_Shoot-transformed.glb'},
            {name:'Dolerite_Dyke',url:'./models/pickstone/breckridge_models/Dolerite_Dyke-transformed.glb'},
            {name:'Mombe_Shoot',url:'./models/pickstone/breckridge_models/Mombe_Shoot-transformed.glb'},
            {name:'Pickstone_Shoot',url:'./models/pickstone/breckridge_models/Pickstone_Shoot-transformed.glb'},
            {name:'Venning_Shoot',url:'./models/pickstone/breckridge_models/Venning_Shoot-transformed.glb'}
                ]   

    },

    {
        'group':'Pickstone',
        'name':'Geology.GeologicalModels',
        'models':
        [   
            {name:'PK_CONC_REEF',url:'./models/pickstone/geological_models/ConcessionModel.glb'},
            {name:'PK_GEO_HG',url:'./models/pickstone/geological_models/PK_UG_GEO_HG-transformed.glb'},
            {name:'PK_GEO_LG',url:'./models/pickstone/geological_models/PK_UG_GEO_LG-transformed.glb'},
            {name:'PK_MAINREEF',url:'./models/pickstone/geological_models/PK_UG_GEO_MR-transformed.glb'},
            {name:'PickstoneOrebody111024',url:'./models/pickstone/geological_models/PickstoneOrebody111024.glb'},
            {name:'ConcessionOrebody111024',url:'./models/pickstone/geological_models/ConcessionOrebody111024.glb'},

            
            {name:'PickstoneFeb25',url:'./models/pickstone/geological_models/pickstone_feb.glb'},
            {name:'DuchessFeb25',url:'./models/pickstone/geological_models/duchess_feb.glb'},
            {name:'VenningFeb25',url:'./models/pickstone/geological_models/venning_feb.glb'},
            {name:'ConcessionFeb25',url:'./models/pickstone/geological_models/concession_feb.glb'},
                ]   

    },

    {
        'group':'Pickstone',
        'name':'Geology.BlockModels',
        'models':
        [   
            {type:'blockmodel',name:'CP',url:'./files/cp_blockmodel.zip', dx:-2.4,dy:0,dz:-300,size:'17mb',grade:'Au_gpt'},
            {type:'blockmodel',name:'TM',url:'./files/tm_blockmodel.zip', dx:0,dy:0,dz:0,size:'9mb',grade:'AU'},
            {type:'blockmodel',name:'VBM',url:'./files/vbm.zip', dx:0,dy:0,dz:0,size:'41mb',grade:'IDAU'},
        ]   

    },


    {
        'group':'Duchess',
        'name':'Duchess.RollerTrend',
        'models':
        [   
            {name:'RollerTrend',url:'./models/pickstone/survey/rollertrend_dev.glb'},
            {name:'DH_REEF',url:'./models/pickstone/duchess/roller_trend_reef.glb'},
            {name:'DH_VOIDS',url:'./models/pickstone/survey/duchess_voids.glb'},
            {name:'DH_DEV',url:'./models/pickstone/survey/duchess_dev.glb'},
                ]   

    },
    
    {
        'group':'Peerless',
        'name':'Survey',
        'models':
        [   
            {name:'PE_PIT',url:'./models/peerless/PE_PIT.glb'},
            {name:'PE_DEV',url:'./models/peerless/PE_UG_Dev.glb'},
                ]   

    },

    {
        'group':'Peerless',
        'name':'PEGeology.Breckridge',
        'models':
        [   
            {name:'PE_OREBODY',url:'./models/peerless/PE_OREBODY1.glb'},
                ]   

    },

    {
        'group':'Peerless',
        'name':'PEGeology.TectModels',
        'models':
        [   
            {name:'PE_BIF',url:'./models/peerless/TECT/PE_BIF.glb'},
            {name:'PE_BLACKSHALE',url:'./models/peerless/TECT/PE_BLACKSHALE.glb'},
            {name:'PE_MODEL_B',url:'./models/peerless/TECT/PE_MODEL_B.glb'},
            {name:'PE_GRADESHALE',url:'./models/peerless/TECT/PE_GRADESHELL.glb'},
            {name:'PE_OVB',url:'./models/peerless/TECT/PE_OVB.glb'},
            {name:'PE_TALC',url:'./models/peerless/TECT/PE_TALC.glb'},
            {name:'PE_VOLC',url:'./models/peerless/TECT/PE_VOLC.glb'},
                ]   

    } ,
    {
        'group':'Holes',
        'name':'Holes',
        'models':
        [
            {type:'assays',name:'UG_ASSAYS',url:'./files/res_master_rcholes.csv'},
            {type:'holes',name:'PKUG_PLAN',url:'./files/Holes070125.zip' , dataset:'BRK_PK_RES_UG', holetype:'DD_PLAN'},
            {type:'holes',name:'PKUG_DD',url:'./files/Holes070125.zip' , dataset:'BRK_PK_RES_UG', holetype:'DD'},
            {type:'holes',name:'DEEPS',url:'./files/Holes070125.zip' , dataset:'PK_Conceptual', holetype:'DD_SFN_DEFLECTION'},
            ]   

    }
    
]